import { createReducer } from 'store/createReducer';
import { IBasket } from 'models/IBasket';
import {
  BASKET_TOGGLE,
  BASKET_CLOSE,
  BASKET_OPEN,
  SHOW_PRODUCT_ADDED,
  HIDE_PRODUCT_ADDED
} from './actions';

export const initialState: IBasket = {
  isOpen: false,
  showProductAdded: false
};

const reducer = {
  [BASKET_TOGGLE]: (state: IBasket) => ({
    ...state,
    isOpen: !state.isOpen,
    showProductAdded: false
  }),
  [BASKET_CLOSE]: (state: IBasket) => ({ ...state, isOpen: false }),
  [BASKET_OPEN]: (state: IBasket) => ({ ...state, isOpen: true }),
  [SHOW_PRODUCT_ADDED]: (state: IBasket) => ({ ...state, showProductAdded: true }),
  [HIDE_PRODUCT_ADDED]: (state: IBasket) => ({ ...state, showProductAdded: false })
};

export default createReducer(initialState, reducer);
